// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"283":"841799a2","590":"36c35b8d","930":"dcbb82f1"}[chunkId] + ".css";
};